module.exports.theNonTrivialFunction = (strIn) -> return "ROOT_TEST_" + strIn